import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Global Styles
import './index.scss';

// Root App Component
import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Render the application inside StrictMode and BrowserRouter.
// StrictMode helps highlight potential issues in the application.
// BrowserRouter enables routing functionality.
root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
